module.exports = __webpack_public_path__ + "2b54e7101f70bab8d26ebdcdabc0fd74.svg";